export const COMMUNITY_BUILD_CATEGORIES = [
  { value: "hauling", label: "Hauling", image: "/ed-icons/ship builds/hauling-trade-type.jpg" },
  { value: "combat", label: "Combat", image: "/ed-icons/ship builds/combat-type.webp" },
  { value: "exploration", label: "Exploration", image: "/ed-icons/ship builds/exploration-type.webp" },
  { value: "mining", label: "Mining", image: "/ed-icons/ship builds/mining-type.png" },
  { value: "anti-xeno", label: "Anti-Xeno", image: "/ed-icons/ship builds/anti-xeno-type.jpg" },
  { value: "specialist", label: "Specialist", image: "/ed-icons/ship builds/specialist-builds-type.png" },
] as const;

export const COMMUNITY_BUILD_ROLES = [
  ...COMMUNITY_BUILD_CATEGORIES.map(({ value, label }) => ({ value, label })),
  { value: "trading", label: "Trading" },
  { value: "passenger", label: "Passenger" },
  { value: "rescue", label: "Rescue" },
  { value: "multipurpose", label: "Multipurpose" },
] as const;

export type CommunityBuildRole = (typeof COMMUNITY_BUILD_ROLES)[number]["value"];

export function categoryForCommunityBuildRole(value: string) {
  const categoryValue = value === "trading" ? "hauling" : ["passenger", "rescue", "multipurpose"].includes(value) ? "specialist" : value;
  return COMMUNITY_BUILD_CATEGORIES.find((category) => category.value === categoryValue) ?? null;
}

export function shipSizeLabel(shipClass: number | null | undefined): string | null {
  if (shipClass === 1) return "Small";
  if (shipClass === 2) return "Medium";
  if (shipClass === 3) return "Large";
  return null;
}

export function landingPadLabel(shipClass: number | null | undefined): string | null {
  return shipSizeLabel(shipClass);
}
